import { create } from 'zustand';
import { ResponsibleModel } from '@/features/responsible/types';
import { CardModel, ColumnModel } from '@/features/crm/types';
import { TypesCRM } from '@/types/crm.ts';

interface ModalState {
  filters: any;
  type: TypesCRM;
  step: ColumnModel | null;
  card: CardModel | null;
  columns: ColumnModel[] | null;
  serieId: number | null;
  responsible: ResponsibleModel | null;
  openResponsible: boolean;
  openCardResponsible: boolean;
  toggleResponsible: (isOpen: boolean) => void;
  toggleCardResponsible: (isOpen: boolean) => void;
  setStep: (step: ColumnModel | null) => void;
  setResponsible: (responsible: ResponsibleModel | null) => void;
  setSerieId: (serieId: number | null) => void;
  setCard: (card: CardModel | null) => void;
  setColumns: (card: ColumnModel[] | null) => void;
  setType: (type: TypesCRM) => void;
  setFilters: (filters: any) => void;
}

const useModalStore = create<ModalState>((set) => ({
  filters: {},
  type: TypesCRM.MATRICULA,
  step: null,
  card: null,
  columns: [],
  serieId: null,
  responsible: null,
  openResponsible: false,
  openCardResponsible: false,
  toggleResponsible: (isOpen) => set({ openResponsible: isOpen }),
  toggleCardResponsible: (isOpen) => set({ openCardResponsible: isOpen }),
  setStep: (step: ColumnModel | null) => set({ step }),
  setResponsible: (responsible: ResponsibleModel | null) => set({ responsible }),
  setSerieId: (serieId: number | null) => set({ serieId }),
  setCard: (card: CardModel | null) => set({ card }),
  setColumns: (columns: ColumnModel[] | null) => set({ columns }),
  setType: (type: TypesCRM) => set({ type }),
  setFilters: (filters: any) => set({ filters }),
}));

export default useModalStore;
